module.exports = __webpack_public_path__ + "img/icon-pdf.df6790a8.png";